import { GetterTree } from 'vuex'
import { NotesState } from '@/store/modules/notes/notesTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<NotesState, RootState> = {
  getNotes(state): {} | [] {
    return state.notes
  }
}
